import { render, staticRenderFns } from "./MonitoringDashboard.vue?vue&type=template&id=27147165&"
import script from "./MonitoringDashboard.vue?vue&type=script&lang=js&"
export * from "./MonitoringDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports